<template>
  <div class="page-dashboard">
    <!-- <Navigation class="hide-pc" :elements="elements" :container="container"/> -->
    <WatchModal :show="false"/>
    <ModalZoomIframe />

    <div class="dashboard" id="dashboard-content" ref="container">
      <div :class="{ 'dashboard-item--active': navActive === 'Today' }" class="today-events dashboard-item" ref="Today">
        <div class="head">
          <h3>{{ $t('pages.dashboard.today') }}</h3>
          <router-link :to="{ name: 'Schedule' }" tag="button" class="white">
            <span>{{ $t('pages.dashboard.full-timetable') }}</span>
            <img src="@/assets/icons/arrow-r.svg" alt="" />
          </router-link>
        </div>
        <ListEvents
            class="list"
            :list="eventsToday"
            @watch-video="watchEventVideo"
            @watch-zoom="watchZoom"
        />
      </div>
      <div>
<!--        <div-->
<!--          class="important-list dashboard-item"-->
<!--          :class="{ 'dashboard-item&#45;&#45;active': navActive === 'Important' }"-->
<!--          ref="Important"-->
<!--        >-->
<!--          <div class="head hide-mobile">-->
<!--            <h3>{{ $t('pages.dashboard.important.title') }}</h3>-->
<!--          </div>-->
<!--          <ImportantItems />-->
<!--        </div>-->
        <div
          class="notifications-list dashboard-item"
          :class="{ 'dashboard-item--active': navActive === 'Notifications' }"
          ref="Notifications"
        >
          <div class="head">
            <h3>{{ $t('pages.dashboard.notifications') }}</h3>
            <router-link tag="button" :to="{ name: 'Notifications' }" class="white">
              <span>{{ $t('pages.dashboard.all-notifications') }}</span>
              <img src="@/assets/icons/arrow-r.svg" alt="" />
            </router-link>
          </div>
          <NotificationsList :list="logsToday" />
        </div>
      </div>
    </div>

    <PanelInfo @change="changeActive" :nav-elements="navElements" :nav-active="navActive" />
  </div>
</template>

<script>
import PanelInfo from '@/components/dashboard/PanelInfo'
import Navigation from '@/components/dashboard/Navigation'
import ImportantItems from '@/components/dashboard/ImportantItems'
import ListEvents from '@/components/events/ListEvents'
import NotificationsList from '@/components/notifications/NotificationsList'

import getEvents from '@/mixins/getEvents'
import _inRange from 'lodash/_baseInRange'
import moment from 'moment'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import {$vfm} from "vue-final-modal";
import ModalZoomIframe from "@/components/modals/ModalZoomIframe";
import WatchModal from "@/components/WatchModal";

export default {
  name: 'Dashboard',
  components: {WatchModal, ModalZoomIframe, NotificationsList, ListEvents, ImportantItems, Navigation, PanelInfo },
  mixins: [getEvents],
  data: () => ({
    elements: {
      Today: undefined,
      Important: undefined,
      Notifications: undefined,
    },
    container: undefined,
    navElements: ['Important', 'Today', 'Notifications'],
    navActive: 'Important',
  }),
  computed: {
    upcomingEvent() {
      const startDay = +moment(this.currentTime).startOf('day')
      return this.events.find(({ time_start }) => time_start >= startDay) || {}
    },
    upcomingEventDate() {
      const { time_finish } = this.upcomingEvent
      if (+moment().startOf('day') === +moment(time_finish)) {
        return 'Today'
      } else {
        return moment(time_finish).format('D MMMM')
      }
    },
    eventsToday() {
      const { time_finish } = this.upcomingEvent
      const startDay = +moment(time_finish).startOf('day')
      const endDay = +moment(time_finish).endOf('day')
      return this.events.filter(({ time_finish }) => _inRange(time_finish, startDay, endDay))
    },
    logsToday() {
      if (this.notifications && !this.notifications.length) return [];
      const filtered = this.notifications.filter(({read_at}) => {return read_at == null;}).slice(0, 3);
      return filtered;
    },
    ...mapState('events', ['logs']),
    ...mapState('notifications', ['unread']),
    ...mapState(['currentTime']),
    ...mapState('notifications', ['notifications']),
    ...mapGetters('events', ['notificationNew']),
  },
  methods: {
    watchEventVideo(event) {
      if(event.video_link) {
        $vfm.show('watchModal', {
          resource: event
        })
      } else {
        this.$toast({ title: 'Video not available' })
      }
    },
    watchZoom(event) {
      $vfm.show('zoomModalIframe', {
        resource: event,
        zoom: {},
      })
    },
    changeActive(name) {
      this.navActive = name
    },
    update() {
      this.getNotifications().then(({ data }) => {
        this.setLogsIdsViewed(data.map(({ id }) => id))
      })
    },
    handleSelectChange(id) {
      this.filters.sort = id
    },
    ...mapMutations('events', ['setLogsIdsViewed']),
    ...mapActions('notifications', ['getNotifications']),
  },
  created() {
    if (!this.logs.length || this.notificationNew) {
      this.update()
    }
  },
  mounted() {
    this.$nextTick(() => {
      Object.keys(this.elements).forEach((key) => {
        this.elements[key] = this.$refs[key]
      })
      this.container = this.$refs.container
    })
  },
  watch: {
    notificationNew(v) {
      if (v) {
        this.update()
      }
    },
  },
}
</script>

<style lang="scss">
.page-dashboard {
  @include PC {
    margin-top: 37px;
  }

  .dashboard {
    flex: 1;
    @include mobile {
      background: $white;
      padding: 0 20px;
      height: calc(100vh - 240px - 62px);
      overflow-y: scroll;
    }

    @include PC {
      display: grid;
      grid-template-columns: 340px 1fr;
      grid-column-gap: 25px;
    }

    .dashboard-item {
      @include mobile {
        display: none;
      }
    }

    .dashboard-item--active {
      @include mobile {
        display: block;
      }
    }

    .dashboard-item > .head {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 28px 0 35px;
      min-height: 35px;

      @include mobile {
        margin: 20px 0;
      }

      h3 {
        font-weight: 700;
        font-size: 16px;
        line-height: 117.5%;
        color: #474747;
        margin: 0 0 8px;
      }

      button {
        padding: 7px 15px;

        &.white {
          font-weight: 700;
          font-size: 15px;
          line-height: 20px;
          color: #ccd7e6;

          &:hover {
            color: #003882;
          }
        }

        img {
          margin: 0 0 0 12px !important;
        }
      }
    }
  }
  .dashboard {
    .important-list,
    .notifications-list {
      .head {
        align-items: center;
        margin-bottom: 38px;
      }
    }

    .notifications-list {
      .head {
        margin-bottom: 18px;
      }
    }
  }
}
</style>
